import { ProfileWriting } from './ProfileWriting'
import { withProfileWriting } from './withProfileWriting'

const ConnectedProfileWriting = withProfileWriting(ProfileWriting)

export { ConnectedProfileWriting as ProfileWriting }
